import React from "react";

const FullscreenSpinner = () => {
  return (
    <div>
      <style>
        {`
          .overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5); /* fondo oscuro semi-transparente */
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999; /* encima de todo */
          }

          /* Spinner de tres bolitas */
          .spinner {
            display: flex;
            gap: 10px;
          }

          .spinner div {
            width: 15px;
            height: 15px;
            background-color: #fff; /* color blanco para resaltar sobre fondo oscuro */
            border-radius: 50%;
            animation: bounce 0.6s infinite alternate;
          }

          .spinner div:nth-child(2) {
            animation-delay: 0.2s;
          }

          .spinner div:nth-child(3) {
            animation-delay: 0.4s;
          }

          @keyframes bounce {
            to {
              transform: translateY(-15px);
            }
          }
        `}
      </style>
      <div className="overlay">
        <div className="spinner">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default FullscreenSpinner;
